import { render, staticRenderFns } from "./ServicePointsMap.vue?vue&type=template&id=53e417b8&"
import script from "./ServicePointsMap.vue?vue&type=script&lang=ts&"
export * from "./ServicePointsMap.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports